(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhopal-banner-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nursery-slider'))customElements.define('nursery-slider',class extends HTMLElement{
connectedCallback(){this.slides=[...this.querySelectorAll('.ns-slide')];this.dots=[...this.querySelectorAll('[data-index]')];this.index=0;this.paused=this.dataset.auto!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1));this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.index))));this.pause=this.querySelector('[data-pause]');this.pause?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()});this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.start());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',()=>this.start());this.editor=e=>{let i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.show(i);this.stop()}};document.addEventListener('shopify:block:select',this.editor);this.sync()}
show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.index);this.dots.forEach((b,n)=>b.setAttribute('aria-current',String(n===this.index)));this.start()}
sync(){if(this.pause){this.pause.textContent=this.paused?'▶':'Ⅱ';this.pause.setAttribute('aria-pressed',String(this.paused))}this.start()}
stop(){clearInterval(this.timer)}
start(){this.stop();if(!this.paused&&this.slides.length>1)this.timer=setInterval(()=>{if(!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show(this.index+1)},Number(this.dataset.delay))}
disconnectedCallback(){this.stop();document.removeEventListener('shopify:block:select',this.editor)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursery-banner-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nursery-slider'))customElements.define('nursery-slider',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.slides=[...this.querySelectorAll('.ns-slide')];this.dots=[...this.querySelectorAll('[data-index]')];this.index=0;this.paused=this.dataset.auto!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.index-1));this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1));this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.index))));this.pause=this.querySelector('[data-pause]');this.pause?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()});this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.start());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',()=>this.start());this.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'){this.touch={x:e.clientX,y:e.clientY};this.stop()}});this.addEventListener('pointerup',e=>{if(!this.touch)return;const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));else this.start()});this.addEventListener('pointercancel',()=>{this.touch=null;this.start()});this.editor=e=>{let i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.show(i);this.stop()}};document.addEventListener('shopify:block:select',this.editor);this.sync()}
show(i){if(!this.slides.length)return;this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.index);this.dots.forEach((b,n)=>b.setAttribute('aria-current',String(n===this.index)));this.start()}
sync(){if(this.pause){this.pause.textContent=this.paused?'▶':'Ⅱ';this.pause.setAttribute('aria-pressed',String(this.paused));this.pause.setAttribute('aria-label',this.paused?'Resume automatic slides':'Pause automatic slides')}this.start()}
stop(){clearInterval(this.timer)}
start(){this.stop();if(!this.paused&&this.slides.length>1)this.timer=setInterval(()=>{if(!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show(this.index+1)},Number(this.dataset.delay)||8000)}
disconnectedCallback(){this.stop();document.removeEventListener('shopify:block:select',this.editor)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tn-shopping-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tn-starter-kit'))customElements.define('tn-starter-kit',class extends HTMLElement{
connectedCallback(){this.options=[...this.querySelectorAll('[data-kit-variant]')];this.btn=this.querySelector('[data-kit-add]');this.status=this.querySelector('[role=status]');this.options.forEach(s=>s.addEventListener('change',()=>this.total()));this.total();this.btn.addEventListener('click',async()=>{this.btn.disabled=true;this.status.textContent='Adding your selected kit…';try{const items=this.options.map(s=>({id:Number(s.value),quantity:1}));if(!items.length||items.some(i=>!i.id))throw Error('Please choose available products.');const result=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const data=await result.json();if(!result.ok)throw Error(data.description||'Please check product availability and try again.');location.assign((window.Shopify?.routes?.root||'/')+'cart')}catch(e){this.status.textContent=e.message;this.btn.disabled=false}})}
total(){const sum=this.options.reduce((n,s)=>n+Number(s.selectedOptions[0]?.dataset.price||0),0);this.querySelector('.tn-kit-total').textContent='Kit total: '+new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR'}).format(sum/100)}
});

  } catch(e) { console.error(e); }
})();
})();
